// extracted by mini-css-extract-plugin
export default {"base":"PieChartDisplay_base__ZHqae","select":"PieChartDisplay_select__UA6FS"};